import { sarangRoutes } from "./sarang-routes";
import { authRoutes } from "./auth-routes";
import { adminRoutes } from "./admin-routes";
import { otherRoutes } from "./other-routes";

export const allRoutes = [
    ...authRoutes,
    ...adminRoutes,
    ...sarangRoutes,
    ...otherRoutes
];
